import React from 'react';
import AccordionContainer from '../../Componant/UiKits/Accordian';

const Accordion = () => {
  return (
    <div className='page-body'>
      <AccordionContainer />
    </div>
  );
};

export default Accordion;
